export default __webpack_public_path__ + "static/media/List-documentation.054d5089.md";